const BuildingConstant = {
  GET_BUILDING_LIST_SUCCESS: "GET_BUILDING_LIST_SUCCESS",
  GET_BUILDING_LIST_FAILURE: "GET_BUILDING_LIST_FAILURE",

  ADD_OR_UPDATE_BUILDING_LIST_SUCCESS: "ADD_OR_UPDATE_BUILDING_LIST_SUCCESS",
  ADD_OR_UPDATE_BUILDING_LIST_FAILURE: "ADD_OR_UPDATE_BUILDING_LIST_FAILURE",

  DEL_BUILDING_SUCCESS: "DEL_BUILDING_SUCCESS",
  DEL_BUILDING_FAILURE: "DEL_BUILDING_FAILURE",
};

export default BuildingConstant;
